export function getIsHomePage() {
  return location.pathname === "" || location.pathname === "/";
}
